// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo_logo__fq_R_","logoWithTest":"HeaderLogo_logoWithTest__8usQ5","logoLink":"HeaderLogo_logoLink__EHknZ","customDate":"HeaderLogo_customDate__OF_rv"};